export default class AppController {
    /** @ngInject */
    constructor(UiTreeHelper) {
        this.UiTreeHelper = UiTreeHelper;
    }

    $onInit() {
        // redefine method for calculation correct width
        this.UiTreeHelper.width = function (element) {
            return element.prop('clientWidth');
        };
    }
}



// WEBPACK FOOTER //
// ./app/app.controller.js